import { flatten } from 'ramda';
import { PaymentMethod } from '../../api/config/types';
import { PAYMENT_SERVICE_IDS } from '../../constants';
import {
  ActiveNetwork,
  CMSPaymentServicesDescription,
  PaymentService
} from '../../types/paymentService';

interface FilteredSystem {
  limits?: {
    max?: number;
    min?: number;
  };
  networks?: ActiveNetwork[];
}

export const parseServices = (
  type: 'deposit' | 'withdraw',
  paymentSystems: PaymentMethod[],
  paymentServicesDescription: CMSPaymentServicesDescription,
  currency: string
) => {
  const availableServiceIds = flatten(Object.values(PAYMENT_SERVICE_IDS));
  const availableServiceDescriptionList = Object.keys(
    paymentServicesDescription
  );
  const filteredSystems = paymentSystems.filter(
    ({ serviceId }) =>
      availableServiceIds.includes(serviceId) &&
      availableServiceDescriptionList.includes(`${serviceId}`) &&
      availableServiceDescriptionList.includes(String(serviceId))
  );

  return {
    ids: filteredSystems.map(({ serviceId }) => serviceId),
    data: filteredSystems.reduce(
      (acc, system) => {
        const {
          limits: { max: maxLimit = 0, min: minLimit = 0 } = {},
          networks = []
        } = system as FilteredSystem;
        const limits = {
          max: Number(maxLimit),
          min: Number(minLimit)
        };
        const defaultNetwork = networks.find(({ isDefault }) => isDefault);
        const { [type]: configByType = {}, ...rest } =
          paymentServicesDescription[system.serviceId] || {};
        acc[system.serviceId] = {
          ...rest,
          ...configByType,
          ...system,
          limits,
          serviceId: system.serviceId,
          currency,
          activeNetwork: defaultNetwork
        };

        return acc;
      },
      {} as Record<number, PaymentService>
    )
  };
};
